(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Application.FormsPipeline",
            {
                url: "/FormsPipeline",
                component: "formsPipeline",
                resolve: {
                    prevStage: ["transaction", function (transaction) {
                        return transaction.DeterminePoints.includes("DetermineDocuments")
                            ? "Transaction.Determine.Documents"
                            : "Transaction.Determine.ProductShelf";
                    }],
                    inforce: ["transaction", "inforceTransactionApi", function (transaction, inforceTransactionApi) {
                        return inforceTransactionApi.get(transaction.Id).catch(ng.noop);
                    }],
                    nextStage: ["inforce", function(inforce) {
                        if (inforce)
                            return "Transaction.Application.InforceApplication";
                        else
                            return "Transaction.Application.PaperApplication";
                    }]
                },
                onEnter: ["transaction", "transactionApi", function (transaction, transactionApi) {
                    transaction.LastTransactionStage = "FormsPipeline";
                    transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                }]
            });
    }]);

    app.component("formsPipeline",
        {
            templateUrl: "/App/Transaction/Application/FormsPipeline/template.html",
            controller: formsPipelineController,
            bindings: {
                transaction: "<",
                applicationDocuments: "<",
                prevStage: "<",
                nextStage: "<"
            }
        });

    formsPipelineController.$inject = ["$state", "$scope", "Upload", "transactionApi", "_", "$mdDialog", "iPipelineApi"];
    function formsPipelineController($state, $scope, Upload, transactionApi, _, $mdDialog, iPipelineApi) {
        var $ctrl = this;
        $scope.$parent.$ctrl.getCurrentStage($state);

        $ctrl.ui = {
            Saving: []
        };

        $ctrl.ui.Saving = false;

        ng.extend($ctrl,
            {
                moreInfo: moreInfo,
                closeDialog: closeDialog
            });

        this.$onInit = function () {
            activateIPipelineSso("forms");
        };

        function moreInfo($event) {
            var info = $mdDialog.show({
                contentElement: "#moreInfo",
                parent: ng.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true
            });
        };

        function closeDialog() {
            $mdDialog.hide();
        }

        function activateIPipelineSso(rsid) {
            var w = document.getElementById('iPipelineFrame');
            w = w.contentWindow || w.contentDocument.document || w.contentDocument;
            w.document.open();
            w.document.write('<center><img src="/Images/pipeline.png"></center>');
            iPipelineApi.initiateiPipelineSso(rsid).then(function (data) {
                w.document.write(data);
                w.document.forms.samlform.submit();
                w.document.close();
            }, function () {
                w.document.write(" Failed.  There was an error accessing this resource.");
                w.document.close();
            });
        }
    }

})(window.app, window.angular);